// React Dependencies
import React from 'react';

// Internal Dependencies
import ContriPOITable from './table';
import MText from '../common/MText';
import Colours from '../../styles/colours';

const ContriPoiList = () => (
  <div>
    <div className="content-header">
      <MText variant="h1" text="Contribute POIs" bold colour={Colours.Gray6} />
    </div>
    <ContriPOITable />
  </div>
);

export default ContriPoiList;
